import { validateError } from './error_map';

export const AuthErrorSource = {
    COGNITO: 'cognito',
    ECAL: 'ecal',
};

/**
 * Creates a fallback error object when validateError returns null
 * Handles AWS Amplify v6 error structure where 'name' is used instead of 'code'
 *
 * @param {Object} error - The original error object from Cognito
 * @returns {Object|null} - A formatted error object with a 'code' or 'message' field
 */
export function createFallbackError (error) {
    if (!error) {
        return null;
    }

    console.log('Creating fallback error object');

    // AWS Amplify v6 uses 'name' field instead of 'code'
    // Try to map by error.name if error.code doesn't exist
    const errorCode = error?.code || error?.name;
    const mappedError = validateError({ ...error, code: errorCode });

    console.log('Fallback Error Validated Mapped Error: ', mappedError);

    // If still null, create a generic error with the message
    if (mappedError === null) {
        return {
            message: error?.message || 'Something went wrong. Our technical team are looking into the problem. Please try again later or contact ECAL Support.',
        };
    }

    return mappedError;
}

export function handleAuthError ({ error, action, source }) {
    // console.log('handleAuthError() action: ', action);
    // console.log('handleAuthError() source: ', source);
    // console.log('handleAuthError() error: ', JSON.stringify(error, null, 2));

    if (source === AuthErrorSource.COGNITO) {
         let err = validateError(error);
         console.log('Cognito Error Validated Mapped Error : ', err);

         // If validateError returns null, create a fallback error object
         if (err === null && error) {
            err = createFallbackError(error);
         }

         if (err !== null) {
            this.authError = {};
            this.authError[action] = err;
            return {
                hasError: true,
            };
         }
    }
    return {
        hasError: false,
    };
}
